// extracted by mini-css-extract-plugin
module.exports = {"PositiveAmount":"RowProwider_PositiveAmount__3gcTA","NegativeAmount":"RowProwider_NegativeAmount__rsmS7","Amount":"RowProwider_Amount__2Pd8a"};